import { developmentPlanConstants } from '../../_constants';
import { developmentPlanService } from '../../_services';
import { developmentPlanActions } from './getDevelopmentPlan.action';

export const updateRespondents = {
    updateRespondentsHandler
};

function updateRespondentsHandler(data, id) {

    return dispatch => {
        dispatch(request());
        developmentPlanService.updateRespondentsHandler(data, id)
            .then(
                updateRespondentsData => {
                    dispatch(developmentPlanActions.getDevelopmentPlan())
                    dispatch(success(updateRespondentsData));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: developmentPlanConstants.REQUEST_UPDATE_RESPONDENTS } }
    function success(updateRespondentsData) { return { type: developmentPlanConstants.RECEIVE_UPDATE_RESPONDENTS, updateRespondentsData } }
    function failure(error) { return { type: developmentPlanConstants.UPDATE_RESPONDENTS_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/DevelopmentPlan/updateRespondents.action.js